import { render, staticRenderFns } from "./SSelect.vue?vue&type=template&id=0ec6c96c&scoped=true&"
import script from "./SSelect.vue?vue&type=script&lang=ts&"
export * from "./SSelect.vue?vue&type=script&lang=ts&"
import style0 from "./SSelect.vue?vue&type=style&index=0&id=0ec6c96c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec6c96c",
  null
  
)

export default component.exports